// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_g9-3";
export var flatBottomCorners = "_g9-5";
export var productImage = "_g9-0";
export var quantityContainer = "_g9-2";
export var quantityHeader = "_g9-6";
export var tooltip = "_g9-1";
export var wrapAndEllipsesOverflow = "_g9-4";